/* Café Arona — chrome interactivity (slice-3).
   One init function per chrome behaviour; later slice-3 tasks add
   modules here (nav dropdowns, mobile menu). */
(function () {
  'use strict';

  /* Announcement bar — dismiss, remembered for the visit via localStorage. */
  function initAnnouncementBar() {
    var bar = document.querySelector('[data-announcement]');
    if (!bar) return;

    var STORAGE_KEY = 'arona:announcement-dismissed';
    var isDismissed = false;
    try {
      isDismissed = localStorage.getItem(STORAGE_KEY) === '1';
    } catch (error) {
      /* localStorage unavailable (private mode) — show the bar. */
    }

    if (isDismissed) {
      bar.hidden = true;
      return;
    }

    var button = bar.querySelector('[data-announcement-dismiss]');
    if (!button) return;

    button.addEventListener('click', function () {
      bar.hidden = true;
      try {
        localStorage.setItem(STORAGE_KEY, '1');
      } catch (error) {
        /* localStorage unavailable — dismissal won't persist. */
      }
    });
  }

  /* Desktop nav dropdowns — click + hover toggle. aria-expanded is the single
     source of truth; CSS reveals the panel when it is true. */
  function initNavDropdowns() {
    var toggles = document.querySelectorAll('.site-nav__toggle');
    if (!toggles.length) return;

    function setOpen(toggle, open) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    function isOpen(toggle) {
      return toggle.getAttribute('aria-expanded') === 'true';
    }
    function closeAll(except) {
      toggles.forEach(function (toggle) {
        if (toggle !== except) setOpen(toggle, false);
      });
    }

    toggles.forEach(function (toggle) {
      var item = toggle.closest('.site-nav__item');

      toggle.addEventListener('click', function () {
        var open = !isOpen(toggle);
        closeAll(toggle);
        setOpen(toggle, open);
      });

      if (!item) return;
      item.addEventListener('mouseenter', function () {
        closeAll(toggle);
        setOpen(toggle, true);
      });
      item.addEventListener('mouseleave', function () {
        setOpen(toggle, false);
      });
      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) setOpen(toggle, false);
      });
    });

    /* Escape closes the open panel and returns focus to its toggle. */
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      toggles.forEach(function (toggle) {
        if (!isOpen(toggle)) return;
        var item = toggle.closest('.site-nav__item');
        var hadFocus = item && item.contains(document.activeElement);
        setOpen(toggle, false);
        if (hadFocus) toggle.focus();
      });
    });

    /* A click outside an open dropdown closes it. */
    document.addEventListener('click', function (event) {
      toggles.forEach(function (toggle) {
        if (!isOpen(toggle)) return;
        var item = toggle.closest('.site-nav__item');
        if (item && !item.contains(event.target)) setOpen(toggle, false);
      });
    });
  }

  /* Mobile menu — a panel anchored directly below the header. The hamburger
     is the single toggle; it swaps to an X via aria-expanded. Focus trap
     while open; scroll lock is CSS-driven (critical.css :has() rule). */
  function initMobileMenu() {
    var menu = document.querySelector('[data-mobile-menu]');
    var toggle = document.querySelector('[data-mobile-menu-toggle]');
    var header = document.querySelector('.site-header');
    if (!menu || !toggle || !header) return;

    var FOCUSABLE = 'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])';

    function isOpen() {
      return toggle.getAttribute('aria-expanded') === 'true';
    }

    /* Anchor the panel to the header's bottom edge so it drops in below it,
       never over it — the header (logo, cart, X) stays put. */
    function positionMenu() {
      menu.style.top = header.getBoundingClientRect().bottom + 'px';
    }

    function visibleFocusables() {
      return [toggle].concat(
        Array.prototype.filter.call(
          menu.querySelectorAll(FOCUSABLE),
          function (el) { return el.offsetParent !== null; }
        )
      );
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        closeMenu();
        toggle.focus();
        return;
      }
      if (event.key !== 'Tab') return;
      var items = visibleFocusables();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function openMenu() {
      positionMenu();
      menu.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', toggle.getAttribute('data-label-close'));
      /* Move focus into the panel so keyboard/SR users land inside the trap.
         The panel container (not the search input) — avoids popping the
         on-screen keyboard. */
      menu.focus({ preventScroll: true });
      document.addEventListener('keydown', onKeydown);
      window.addEventListener('resize', positionMenu);
    }

    function closeMenu() {
      menu.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', toggle.getAttribute('data-label-open'));
      document.removeEventListener('keydown', onKeydown);
      window.removeEventListener('resize', positionMenu);
    }

    toggle.addEventListener('click', function () {
      if (isOpen()) closeMenu();
      else openMenu();
    });

    /* Inline accordions for nav items that have children. */
    menu.querySelectorAll('.mobile-nav__toggle').forEach(function (navToggle) {
      navToggle.addEventListener('click', function () {
        var expanded = navToggle.getAttribute('aria-expanded') === 'true';
        navToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      });
    });
  }

  function init() {
    initAnnouncementBar();
    initNavDropdowns();
    initMobileMenu();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
